module.exports = __webpack_public_path__ + "static/media/isometrics.3b32263f.png";